<form [formGroup]="form" formSanitizer (ngSubmit)="onSave()">
  <div mat-dialog-title>
    <h1>Add new recipient</h1>
  </div>
  <mat-dialog-content flexLayout="row">
    <mat-form-field flex>
      <mat-label>Recipient</mat-label>
      <input title="Recipient" matInput required type="text" formControlName="recipient" />
    </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions flexLayoutAlign="end center">
    <button type="button" mat-flat-button (click)="onCancel()">Cancel</button>
    <button type="submit" mat-raised-button color="primary" [disabled]="form.invalid">
      Commit
    </button>
  </mat-dialog-actions>
</form>
